import React from 'react'
import { Form, Input, Row, Col, Message } from 'antd'
import { getPrices, postPrices } from '../../../api/businessCommodity'
import '../Merchandise/style.css'

export default class extends React.Component {
  state = {
    amount: '',
    diamond: '',
    diamondAmount: '',
    commission: '',
    newListingId: '',
  }

  componentDidMount() {
    if (this.props.modalState == 'isDetails') {
      this.getPricesData()
      this.setState({
        newListingId: this.props.newListingId,
      })
    }
    if (this.props.modalState == 'isAddCommodity') {
      this.setState({
        newListingId: this.props.newListingId,
      })
    }
  }

  setNewListingId = (id) => {
    this.setState({
      newListingId: id,
    })
  }

  getPricesData = async () => {
    const listingId = this.props.allData.commodity.id
    const { data, detail, status } = await getPrices(listingId)
    if (status == 1) {
      this.setState({
        ...data,
        amount: data.amount / 100,
        diamondAmount: data.diamondAmount / 100,
        commission: data.commission / 100,
      })
    } else {
      Message.error(detail)
    }
  }

  postNewSelling = async () => {
    const { amount, diamond, diamondAmount, commission, newListingId } =
      this.state
    if (amount) {
      this.props.setConfirmLoading(true)
      const params = {
        amount: (amount * 100).toFixed(0),
        diamond: diamond,
        diamondAmount: (diamondAmount * 100).toFixed(0),
        commission: (commission * 100).toFixed(0),
      }
      if (this.props.modalState == 'isAddCommodity') {
        params.id = -1
        params.listingId = newListingId
      }
      if (this.props.modalState == 'isDetails') {
        params.listingId = this.props.allData.price.listingId
        params.id = this.props.allData.price.id
      }
      const { data, detail, status } = await postPrices(params)
      if (status == 1) {
        if (this.props.modalState == 'isAddCommodity') {
          Message.success('保存成功')
          this.props.setActiveTab('3')
          this.props.setConfirmLoading(false)
        }
        if (this.props.modalState == 'isDetails') {
          Message.success('保存成功')
          this.props.setConfirmLoading(false)
          this.props.setIsVisible(false)
          this.props.getList()
        }
      } else {
        Message.error(detail)
        this.props.setConfirmLoading(false)
      }
    } else {
      Message.error('请完整填写信息')
    }
  }

  render() {
    const { amount, diamond, diamondAmount, commission } = this.state
    return (
      <Form labelCol={{ span: 5 }} wrapperCol={{ span: 19 }}>
        <Form.Item
          label={
            <span>
              <span className="color_red">* </span>
              <span>销售单价</span>
            </span>
          }
        >
          <Row gutter={8}>
            <Col span={7}>
              <Input
                value={amount}
                onChange={(e) => this.setState({ amount: e.target.value })}
              />
            </Col>
            <Col span={4} className="diamond">
              元
            </Col>
          </Row>
        </Form.Item>

        <Form.Item label="钻石抵扣">
          <Input.Group>
            <Row gutter={8}>
              <Col span={7}>
                <Input
                  value={diamond}
                  onChange={(e) => this.setState({ diamond: e.target.value })}
                />
              </Col>
              <Col span={4} className="diamond">
                钻石 +
              </Col>
              <Col span={7}>
                <Input
                  value={diamondAmount}
                  onChange={(e) =>
                    this.setState({ diamondAmount: e.target.value })
                  }
                />
              </Col>
              <Col span={4} className="diamond">
                元
              </Col>
            </Row>
          </Input.Group>
        </Form.Item>

        {/* <Form.Item label="销售提成">
          <Row gutter={8}>
            <Col span={7}>
              <Input
                value={commission}
                onChange={(e) => this.setState({ commission: e.target.value })}
              />
            </Col>
            <Col span={4} className="diamond">
              元
            </Col>
          </Row>
        </Form.Item> */}
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/purchaseSalesInventory/components/selling.js